import { route } from 'frontend/inertia/routes'

// Unpoly-served pages the user menu links to.

export const sessionPath = {
  // mirrors new_user_session
  new: route('/users/sign_in'),
  // mirrors destroy_user_session
  destroy: route('/users/sign_out'),
}

export const registrationPath = {
  // mirrors new_user_registration
  new: route('/users/sign_up'),
  // mirrors frontend_users_education_info_step
  educationInfo: route('/users/registration_steps/education_info'),
  // mirrors edit_user_registration
  edit: route('/users/edit'),
}

export const accountPath = {
  // mirrors edit_frontend_user
  edit: route('/user/edit'),
}

export const userHomePath = {
  // mirrors frontend_users_home
  show: route('/users/home'),
}

export const userListsPath = {
  // mirrors video_platform_frontend_custom_playlists
  customPlaylists: route('/custom_playlists'),
  // mirrors frontend_users_bookmarks
  bookmarks: route('/users/merkliste'),
  // mirrors frontend_users_history
  history: route('/users/historie'),
}

export const adminPath = {
  // mirrors admin_root
  root: route('/admin'),
  // mirrors career_admin_companies
  companies: route('/admin/companies'),
  // mirrors career_admin_company_dashboard
  companyDashboard: route('/admin/companies/:company_id/dashboard'),
}
